export default "__VITE_ASSET__CNVcGD$8__"